<template>
  <section class='container py-5 bg-img'>
    <h2 class="text-center" style="color: #fdfaa4;">จำนวนสิทธิคงเหลือ {{ count }} ครั้ง</h2>
    <div class="d-flex justify-content-center ">
      
      <fortune-wheel
        ref='wheel'
        :verify='canvasVerify'
        :canvas='canvasOptionsMk'
        :prizes='prizesMk'
        @rotateEnd='onRotateEnd'
        @buttonClick='btnClicked'
        :duration="10000"
        :timingFun="'cubic-bezier(0,.86,.39,.99)'"
      />
    </div>
    <div id='popupModal' class='popup__modal'>
        <div class='popup__modal__content'>
          <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/main_pop_up.jpg" class="img-fluid rounded" >
        </div>
        <button type="button" class="btn btn-success my-1 buttom__close__popup" @click="closeModalPopUp()">เปิดอั่งเปา</button> 
    </div>
    <div id='rewardModal' class='popup__modal'>
      <div class="reward__modal__content">
        <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_100c.png" v-if="receivedReward == '100 coins'" class="img-fluid modal__img__content fade-in" >
        <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_50c.png" v-else-if="receivedReward == '50 coins'" class="img-fluid modal__img__content fade-in" >
        <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_20p.png" v-else-if="receivedReward == '20 points'" class="img-fluid modal__img__content fade-in" >
        <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_10p.png" v-else-if="receivedReward == '10 points'" class="img-fluid modal__img__content fade-in" >
        <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_10c.png" v-else-if="receivedReward == '10 coins'" class="img-fluid modal__img__content fade-in" >
        <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_2h.png" v-else-if="receivedReward == '2 hours'" class="img-fluid modal__img__content fade-in" > 
        <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_5p.png" v-else class="img-fluid modal__img__content fade-in" >
        <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_box.png" class="img-fluid modal__img__bottom" >
      </div>
      <button type="button" class="btn btn-success my-1 buttom__close" @click="closeModalReward()">ปิด</button>
    </div>
  </section>
</template>
<script>
import FortuneWheel from 'improved-vue-fortune-wheel'
import 'improved-vue-fortune-wheel/lib/improved-vue-fortune-wheel.css'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  components: {
    FortuneWheel
  },
  data () {
    return {
      count: 0,
      prizeId: 0,
      canvasVerify: false,
      canvasOptionsMk: {
        borderColor: '#fdfaa4',
        borderWidth: 5,
        lineHeight: 30,
        textRadius: 210,
        radius: 250,
        btnBgColor: '#31c1d7',
        btnTextColor: '#fff',
        btnText: 'GO',
        btnWidth: 70,
        btnFontSize: 30,
        btnBorderColor: '#fdfaa4'
      },
      // probability: [10, 2, 25, 7, 15, 15, 25, 1],
      prizesMk: [
        {
          id: 1,
          name: '10 Coins',
          value: '10 coins',
          bgColor: '#af2228',
          color: '#fff',
          probability: 10,
          weight: 5
        },
        {
          id: 2,
          name: '100 Coins',
          value: '100 coins',
          bgColor: '#dc2c34',
          color: '#fff',
          probability: 2,
          weight: 5
        },
        {
          id: 3,
          name: '5 Points',
          value: '5 points',
          bgColor: '#af2228',
          color: '#fff',
          probability: 25,
          weight: 5
        },
        {
          id: 4,
          name: '50 Coins',
          value: '50 coins',
          bgColor: '#dc2c34',
          color: '#fff',
          probability: 7,
          weight: 5
        },
        {
          id: 5,
          name: '20 Points',
          value: '20 points',
          bgColor: '#af2228',
          color: '#fff',
          probability: 15,
          weight: 5
        },
        {
          id: 6,
          name: '10 Points',
          value: '10 points',
          bgColor: '#dc2c34',
          color: '#fff',
          probability: 15,
          weight: 5
        },
        {
          id: 8,
          name: '5 Points',
          value: '5 points',
          bgColor: '#af2228',
          color: '#fff',
          probability: 25,
          weight: 5
        },
        {
          id: 7,
          name: 'ฟรี 2 ชม.',
          value: '2 hours',
          bgColor: '#dc2c34',
          color: '#fff',
          probability: 1,
          weight: 5
        }
      ],
      spinDisabled: false,
      receivedReward: '',
      userId: null
    }
  },
  computed: {
    wheel () {
      return this.$refs.wheel
    },
    ...mapGetters({
      user: 'auth/getUser'
    })
  },
  methods: {
    spin () {
      this.wheel.spin()
    },
    spinImage () {
      this.image.spin()
    },
    btnClicked () {
      if (this.userId) {
        const canRotate = this.wheel.canRotate
        if (canRotate) {
          if (this.count > 0) {
            let countRotate = this.count - 1
            this.count = countRotate
            this.spin()
          } else {
            this.$swal('จำนวนสิทธิหมดแล้ว', '', 'error')
          }
        }
      } else {
        this.checkLogin()
      }
    },
    onRotateEnd (prize) {
      this.spinDisabled = true
      this.receivedReward = prize.value
      this.openModelReward()
      this.saveCampaignReward(prize)
    },
    openModelReward () {
      let modal = document.getElementById('rewardModal')
      modal.style.display = 'block'
    },
    closeModalReward  () {
      let modal = document.getElementById('rewardModal')
      modal.style.display = 'none'
    },
    openModelPopUp () {
      let modal = document.getElementById('popupModal')
      modal.style.display = 'block'
    },
    closeModalPopUp () {
      let modal = document.getElementById('popupModal')
      modal.style.display = 'none'
    },
    async saveCampaignReward (data) {
      let params = {
        user_id: this.userId,
        campaign_id: 1,
        reward_id: data.id,
        reward_remark: data.value
      }
      try {
        const { data } = await axios.post('rewards/save-campaign-reward', params)
        if (data.error) {
          this.$swal('บันทึกผลรางวัลผิดพลาด', '', 'error')
        }
      } catch (error) {
      }
    },
    async fetchPromoCodeUsage () {
      const userId = this.userId
      const { data } = await axios.get(`promo-codes/${userId}/count-promo-code-usages`)
      if (!data.error) {
        if (data.count > 0) {
          this.count = data.count
        }
      } else {
        this.$swal('การเชื่อมต่อขัดข้อง', data.message, 'error')
      }
    },
    checkLogin () {
      if (('isLoggingIn' in window.localStorage && window.localStorage.getItem('isLoggingIn') === 'false')) {
        if (this.user === null) {
          this.$parent.openModal('login')
        }
      } else {
        this.$parent.openModal('login')
      }
    },
    async validateUser (userId, validation) {
      try {
        const { data } = await axios.get('/users/validate', {params: {user_id: userId, validation: validation}})
        if (!data.error) {
          this.userId = userId
          this.openModelPopUp()
          this.fetchPromoCodeUsage()
        } else {
          this.checkLogin()
        }
      } catch (e) {
        this.checkLogin()
      }
    }
  },
  mounted () {
    this.userId = null
    const { user_id: queryUserId, validation } = this.$route.query
    if (queryUserId && validation) {
      const userId = queryUserId
      this.validateUser(userId, validation)
    } else {
      if (this.user) {
        this.userId = this.user.id
        this.openModelPopUp()
        this.fetchPromoCodeUsage()
      } else {
        this.checkLogin()
      }
    }
  },
  created () {
    this.userId = null
  },
  watch: {
    user () {
      if (this.user) {
        this.userId = this.user.id
        this.openModelPopUp()
        this.fetchPromoCodeUsage()
      }
    }
  }
}
</script>
<style scoped>
.bg-img {
  background-image: url('https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/bg_main.jpg');
}
.modal__content {
  position: relative;
  left: 50%;
  transform: translateX(-50%)
}
.modal__img__content {
  position: relative;
  width: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}
.modal__img__bottom {
  position: relative;
  width: 60%;
  left: 50%;
  transform: translate(-50%,-20%);
}
.buttom__close__popup {
  position: relative;
  left: 50%;
  width: 50%;
  transform: translate(-50%, 35%);

  @media screen and (min-width: 900px) {
    width: 25%;
  }

  @media screen and (min-width: 1100px) {
    width: 15%;
  }
}
.buttom__close {
  position: relative;
  left: 50%;
  width: 50%;
  transform: translate(-50%, -85%);

  @media screen and (min-width: 900px) {
    width: 25%;
  }

  @media screen and (min-width: 1100px) {
    width: 15%;
  }
}
.fade-in {
  animation: fadeIn ease 5s;
  -webkit-animation: fadeIn ease 5s;
  -moz-animation: fadeIn ease 5s;
  -o-animation: fadeIn ease 5s;
  -ms-animation: fadeIn ease 5s;
}
@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-o-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-ms-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}
.popup__modal {
  display: none;
  position: fixed;
  z-index: 999;
  padding-top: 100px; 
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0, 0, 0, 0.8);
}

.popup__modal__content {
  margin: auto;
  width: 80%;
  @media screen and (min-width: 450px) {
    width: 70%;
  }

  @media screen and (min-width: 700px) {
    width: 60%;
  }

  @media screen and (min-width: 800px) {
    width: 50%;
  }

  @media screen and (min-width: 900px) {
    width: 40%;
  }
  @media screen and (min-width: 1200px) {
    width: 35%;
  }
  @media screen and (min-width: 1300px) {
    width: 30%;
  }
  @media screen and (min-width: 1500px) {
    width: 20%;
  }
}
.reward__modal{
  
}
.reward__modal__content {
  margin: auto;
  width: 100%;

  @media screen and (min-width: 700px) {
    width: 80%;
  }
  @media screen and (min-width: 800px) {
    width: 70%;
  }
  @media screen and (min-width: 900px) {
    width: 60%;
  }
  
  @media screen and (min-width: 1100px) {
    width: 40%;
  }
  @media screen and (min-width: 1200px) {
    width: 35%;
  }
  @media screen and (min-width: 1300px) {
    width: 30%;
  }
  @media screen and (min-width: 1500px) {
    width: 25%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/campaign/luckyRoulette/Index.vue